module.exports = __webpack_public_path__ + "static/media/ticket-on-nick.ec130e63.svg";